import { Alert, AlertColor, Box, Snackbar } from '@mui/material';
import { snackBar } from 'src/content/keywordResearch/keywordOverview/keywordOverviewCSS';
import { useCitation } from '../Providers/CitationProvider';

export const CitationSnackbar = () => {
  const { state: citationState, setError } = useCitation();

  if(!citationState?.error?.status) {
    return null;
  }
  return (
    <>
      <Snackbar
        sx={{ marginTop: '2.8rem' }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={Boolean(citationState?.error?.status)}
        autoHideDuration={5000}
        onClose={() => setError({ status: '', message: '' })}
      >
        <Box>
          <Alert
            icon={
              citationState?.error?.status === 'success' ? (
                <img
                  draggable={false}
                  alt="check icon"
                  src={
                    process.env.PUBLIC_URL +
                    `/static/images/icons/checkIcon.svg`
                  }
                  width="40px"
                  height="27px"
                />
              ) : undefined // fallback to default icon
            }
            onClose={() => setError({ status: '', message: '' })}
            severity={citationState?.error?.status as AlertColor}
            variant="filled"
            sx={{
              ...(citationState?.error?.status === 'success'
                ? snackBar?.alert
                : snackBar?.alertError),
              backgroundColor:
                citationState?.error?.status === 'success'
                  ? 'var(--color-success-bg-ultra)'
                  : 'var(--color-error-bg)',
              border:
                citationState?.error?.status === 'success'
                  ? '1px solid var(--color-success-border)'
                  : '1px solid var(--color-error-red)',
              maxWidth: '667px'
            }}
          >
            {citationState?.error?.message}
          </Alert>
        </Box>
      </Snackbar>
    </>
  );
};
